import React from "react";

interface QuoteProps {
  children: React.ReactNode;
  /** Attribution name. */
  name: string;
  /** Job title. */
  title?: string;
  /** Company name. */
  company?: string;
  className?: string;
}

/**
 * Pull-quote in italic Fraunces. Hairlines top + bottom. No headshot — by design.
 */
export function Quote({ children, name, title, company, className = "" }: QuoteProps) {
  return (
    <figure
      className={`border-y border-latte-300 dark:border-latte-800 py-10 sm:py-12 ${className}`}
    >
      <blockquote className="font-display italic text-2xl sm:text-3xl lg:text-display-sm text-coffee-900 dark:text-cream-50 leading-snug max-w-[40ch]">
        <span className="font-display-italic">{`"`}</span>
        {children}
        <span className="font-display-italic">{`"`}</span>
      </blockquote>
      <figcaption className="mt-6 text-body-sm text-coffee-700 dark:text-cream-200">
        <span className="font-medium text-coffee-900 dark:text-cream-50">{name}</span>
        {(title || company) && (
          <>
            {", "}
            {title}
            {title && company && ", "}
            {company}
          </>
        )}
      </figcaption>
    </figure>
  );
}

export default Quote;
